// extracted by mini-css-extract-plugin
module.exports = {"portraitHeader":"Portrait_portraitHeader__rf0pM","feedbackBox":"Portrait_feedbackBox__JSn3H","feedbackAction":"Portrait_feedbackAction__evlzU"};